import { render, staticRenderFns } from "./WordTile.vue?vue&type=template&id=1b99ed52&scoped=true&"
import script from "./WordTile.vue?vue&type=script&lang=js&"
export * from "./WordTile.vue?vue&type=script&lang=js&"
import style0 from "./WordTile.vue?vue&type=style&index=0&id=1b99ed52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b99ed52",
  null
  
)

export default component.exports